import { cn } from "cn";
import type { ComponentProps } from "react";

/**
 * Поверхность переключателя: единственное место стилей «нажато / не нажато».
 * Её берут вариант `toggle` у `Button` (состояние несёт `aria-pressed`) и
 * `ToggleTile` (состояние несёт `data-pressed`); оба совпадают с вариантом
 * `pressed` из `globals.css`. Копировать эти классы в другое место нельзя.
 */
export const TOGGLE_SURFACE =
  "border-border bg-transparent text-muted-foreground transition-colors duration-[90ms] ease-linear not-pressed:hover:border-foreground/20 hover:text-foreground pressed:border-selection-border pressed:bg-selection pressed:text-foreground";

/**
 * Плитка-переключатель: тот же вид, что у `Button variant="toggle"`, но
 * обёрткой для содержимого с несколькими кнопками (кнопку в кнопку HTML
 * не допускает). Нажатость плитки — свойство `pressed`; сама плитка
 * неинтерактивна, управляют ей вложенные кнопки.
 */
function ToggleTile({
  pressed,
  className,
  ...props
}: ComponentProps<"div"> & { pressed: boolean }) {
  return (
    <div
      data-slot="toggle-tile"
      data-pressed={pressed}
      className={cn("flex items-center rounded-sm border", TOGGLE_SURFACE, className)}
      {...props}
    />
  );
}

export { ToggleTile };
